import angular from 'angular';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { LocalCarts } from '../local-carts.service/localCarts';
import { CartService } from '../service.tn.cart';

SavedCartsIndex.$inject = [
    'localCarts',
    'tn.cart.service',
    '$tnPopover',
    '$state',
];

export function SavedCartsIndex(
    localCarts: LocalCarts,
    cartService: CartService,
    $tnPopover: PopoverService,
    $state) {
    const vm = angular.extend(this, {
        carts: [],
        selectedCart: {},

        //sort binding
        predicate: 'title',
        reverse: 'true',
        setOrder: setOrder,

        //methods
        showBuyCartPopover: showBuyCartPopover,
        buySavedCart: buySavedCart,
        showRemoveCartPopover: showRemoveCartPopover,
        removeSavedCart: removeSavedCart,

        //popovers
        buyCartPopover: {},
        removeCartPopover: {},
    });

    initalize();

    function setOrder(predicate) {
        vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
        vm.predicate = predicate;
        vm.caretClass = vm.reverse ? 'icon-caret-down' : 'icon-caret-up';
    }

    function initalize() {
        vm.carts = localCarts.getFilteredCarts();
        vm.buyCartPopover = $tnPopover.popoverXS(
            angular.element('.popover-saved-cart-buy')
        );
        vm.removeCartPopover = $tnPopover.popoverXS(
            angular.element('.popover-saved-cart-remove')
        );
        setOrder('title');
    }

    function showBuyCartPopover($event, cart) {
        vm.selectedCart = cart;
        vm.buyCartPopover.show($event.currentTarget);
    }

    function buySavedCart() {
        cartService.setCart(vm.selectedCart);
        $state.go('home.checkout.review');
    }

    function showRemoveCartPopover($event, cart) {
        vm.selectedCart = cart;
        vm.removeCartPopover.show($event.currentTarget);
    }

    function removeSavedCart() {
        localCarts.deleteCart(vm.selectedCart);
        vm.removeCartPopover.hide();
    }
}
